var Handlebars = require("/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p>Errors:</p>\n<ul></ul>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./test/it/lib/templates/error_list.hbs
// module id = 1598
// module chunks = 0